import {RouterModule, Routes} from '@angular/router'
import {NgModule} from '@angular/core'
import {JobRequestDetailPageComponent} from './job-request-detail-page/job-request-detail-page.component'
import {JobRequestContactPageComponent} from './job-request-contact-page/job-request-contact-page.component'
import {JobRequestExecutionDetailsPageComponent} from './job-request-execution-details-page/job-request-execution-details-page.component'
import {JobRequestSummaryPageComponent} from './job-request-summary-page/job-request-summary-page.component'
import {JobRequestSuccessPageComponent} from './job-request-success-page/job-request-success-page.component'
import {PUBLIC_ROUTES} from '../../../shared/routing/public.routes'
import {JobRequestPageComponent} from './job-request-page.component'
import {JobRequestGuard} from './job-request.guard'
import {JobRequestOfferingResolver} from './resolvers/job-request-offering.resolver'
import {JobRequestAgentResolver} from './resolvers/job-request-agent.resolver'
import {JobRequestAgencyResolver} from './resolvers/job-request-agency.resolver'
import {JobRequestIntentionComponent} from './job-request-intention/job-request-intention.component'
import {JobRequestEntryStepResolver} from './resolvers/job-request-entry-step.resolver'
import {JobRequestClientExpectationPageComponent} from './job-request-client-expectation-page/job-request-client-expectation-page.component'
import {JobRequestPreferredProResolver} from './resolvers/job-request-preferred-pro.resolver'
import {ClientLastJobResolver} from './resolvers/client-last-job.resolver'

export const routes: Routes = [
  {
    path: '',
    component: JobRequestPageComponent,
    resolve: {
      agency: JobRequestAgencyResolver,
    },
    children: [
      {
        path: '',
        redirectTo: PUBLIC_ROUTES.JOB_REQUEST_INTENTION.routingPath,
        pathMatch: 'full',
      },
      {
        path: PUBLIC_ROUTES.JOB_REQUEST_INTENTION.routingPath,
        component: JobRequestIntentionComponent,
        resolve: {
          offering: JobRequestEntryStepResolver,
          pro: JobRequestPreferredProResolver,
        },
      },
      {
        path: PUBLIC_ROUTES.JOB_REQUEST_CLIENT_EXPECTATION.routingPath,
        component: JobRequestClientExpectationPageComponent,
        resolve: {
          offering: JobRequestOfferingResolver,
        },
      },
      {
        path: PUBLIC_ROUTES.JOB_REQUEST_DETAIL.routingPath,
        component: JobRequestDetailPageComponent,
        resolve: {
          offering: JobRequestOfferingResolver,
          agent: JobRequestAgentResolver,
          pro: JobRequestPreferredProResolver,
          agency: JobRequestAgencyResolver,
        },
      },
      {
        path: PUBLIC_ROUTES.JOB_REQUEST_CONTACT.routingPath,
        component: JobRequestContactPageComponent,
        canActivate: [JobRequestGuard],
        resolve: {
          offering: JobRequestOfferingResolver,
          agency: JobRequestAgencyResolver,
          clientLastJob: ClientLastJobResolver,
        },
      },
      {
        path: PUBLIC_ROUTES.JOB_REQUEST_EXECUTION_TIME.routingPath,
        component: JobRequestExecutionDetailsPageComponent,
        resolve: {
          offering: JobRequestOfferingResolver,
          agency: JobRequestAgencyResolver,
          clientLastJob: ClientLastJobResolver,
        },
      },
      {
        path: PUBLIC_ROUTES.JOB_REQUEST_SUMMARY.routingPath,
        component: JobRequestSummaryPageComponent,
        resolve: {
          offering: JobRequestOfferingResolver,
          agent: JobRequestAgentResolver,
          agency: JobRequestAgencyResolver,
        },
        canActivate: [JobRequestGuard],
      },
    ],
  },
  {path: PUBLIC_ROUTES.JOB_REQUEST_SUCCESS.routingPath, component: JobRequestSuccessPageComponent},
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JobRequestRoutingModule {}
